import React from "react";
import FunnelInsightCard from "./FunnelInsightCard";
import { buildCustomerLifetimeEconomicsChart } from "./funnelChartUtils";
import {
  cleanLines,
  extractTitle,
  stripTitleLines,
  extractTableBlock,
  splitByHeading,
  toBullets,
  toParagraphs,
  extractVerdict,
} from "./funnelUtils";

const FunnelCustomerLifetimeEconomics = ({ markdown = "" }) => {
  const title = extractTitle(markdown) || "Customer Lifetime Economics";
  const lines = stripTitleLines(cleanLines(markdown));
  const { table, before, after } = extractTableBlock(lines);
  const chart = buildCustomerLifetimeEconomicsChart(table);
  const { tail } = splitByHeading(after, "What Does This Mean?");
  const bullets = toBullets(tail);
  let paragraphs = toParagraphs(tail);
  const verdict = extractVerdict(paragraphs);
  if (verdict) paragraphs = paragraphs.slice(0, -1);

  return (
    <FunnelInsightCard
      title={title}
      kicker="LTV Health"
      sections={[
        {
          title: "Lifetime Economics",
          chart,
          chartTitle: "Lifetime Value Curve",
          chartSubtitle:
            "A line chart gives this report some motion and makes cohort style movement easier to feel.",
          table,
          paragraphs: before.length ? toParagraphs(before) : [],
        },
        {
          title: "What Does This Mean?",
          bullets,
          paragraphs,
          verdict,
        },
      ]}
    />
  );
};

export default FunnelCustomerLifetimeEconomics;
